module.exports = __webpack_public_path__ + "img/WP23-Indaba2.6e287b5f.jpg";